import styled from '@emotion/styled'
// import { WidgetContent, TextField, Select } from '@duik/it'
import DatePicker from 'react-datepicker'

export const AddBackHaulBtn = styled.p`
  font-weight: 500;
  font-size: 0.75rem;
  color: #289c91;
  margin: 0;
  &:hover {
    cursor: pointer;
  }
`

export const HaulIdContainer = styled.div<{ fullWidth: boolean }>`
  width: ${({ fullWidth }) => (fullWidth ? undefined : '232px')};
`
export const AssignTruckButton = styled.span`
  color: #289c91;
  &:hover {
    cursor: pointer;
  }
`
export const AssignBySMSButton = styled.span`
  font-size: 14px;
  color: #289c91;
  &:hover {
    cursor: pointer;
  }
`
export const AddStartTimeButton = styled.p`
  padding-right: '30px';
  color: #289c91;
  font-size: 14px;
  &:hover {
    cursor: pointer;
  }
`

export const StyledDatePicker = styled(DatePicker)`
  border: 1px solid #eaedf3 !important;
`

export const FullWidthContainer = styled.div`
  width: 100%;
`
